import { OptionType } from '@components/Select';

export const normalizeYoString = (str: string): string => {
    return str.replace(/ё/g, 'е').replace(/Ё/g, 'Е');
};

export const normalizeYoSearch = async (input: any, loadOptions: (input: string) => Promise<OptionType[]> | void) => {
    // type any goes from lib
    const norm = normalizeYoString(input as string);

    const all = await loadOptions(norm);
    return all?.filter(opt => normalizeYoString(opt.label).toLowerCase().includes(norm.toLowerCase()));
};

export const normalizeYoFilter = (option: OptionType<any>, rawInput: any) => {
    if (!rawInput) return true;

    const label = typeof option.label === 'object' ? normalizeYoString(option.value) : normalizeYoString(option.label);
    const input = normalizeYoString(rawInput);

    return label.toLowerCase().includes(input.toLowerCase());
};
